var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form",
    { on: { submit: _vm.onSubmit } },
    [
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-name",
            label: "Nom",
            "label-for": "input-name",
          },
        },
        [
          _c("b-form-input", {
            attrs: {
              id: "input-name",
              type: "text",
              placeholder: "Exemple : Grands classiques",
              required: "",
            },
            model: {
              value: _vm.form.quiz_name,
              callback: function ($$v) {
                _vm.$set(_vm.form, "quiz_name", $$v)
              },
              expression: "form.quiz_name",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-category",
            label: "Catégorie",
            "label-for": "input-category",
          },
        },
        [
          _c("b-form-select", {
            attrs: { options: _vm.categoriesValues },
            model: {
              value: _vm.form.quiz_category,
              callback: function ($$v) {
                _vm.$set(_vm.form, "quiz_category", $$v)
              },
              expression: "form.quiz_category",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-level",
            label: "Niveau de difficulté",
            "label-for": "input-level",
          },
        },
        [
          _c("b-form-select", {
            attrs: { options: _vm.levelValues },
            model: {
              value: _vm.form.quiz_level,
              callback: function ($$v) {
                _vm.$set(_vm.form, "quiz_level", $$v)
              },
              expression: "form.quiz_level",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("b-row"),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "text-center" },
            [
              _c(
                "b-button",
                {
                  attrs: {
                    disabled: _vm.pending,
                    type: "submit",
                    variant: "primary",
                  },
                },
                [
                  _vm.pending
                    ? _c(
                        "span",
                        [
                          _c("b-spinner", {
                            attrs: { small: "", variant: "light" },
                          }),
                        ],
                        1
                      )
                    : _c("span", [_vm._v("\n          Enregistrer\n        ")]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }